'use client'

import { TableState } from '@/components/ui/TableState'
import { Button } from '@repo/ui/button'
import Link from 'next/link'

export default function NotFound() {
  return (
    <TableState
      title="Page Not Found"
      description="The page you were looking for doesn't exist or has been moved."
      lottieSrc="/animations/no-data-found-crying.json"
      lottieStyle={{ width: '250px', height: '200px' }}
      className="h-screen"
      action={
        <Link href={'/'}>
          <Button variant="outline">Return Home</Button>
        </Link>
      }
    />
  )
}
